$(document).ready(function() {
 
// 一级下拉
$('.procus-option-header').click(function(){
$(this).toggleClass("active");
$(this).siblings('.procus-option-content').slideToggle();
});
// 二级下拉
$('.products-option-input-down>input').click(function() {
$(this).parent().addClass('active').siblings().removeClass('active');
$(this).siblings(".procus-option-input-child ").slideDown();
 $(this).parent().siblings().children(".procus-option-input-child ").slideUp();
});
$('.procus-option-input').click(function() {
    $(this).addClass("active").siblings().removeClass('active');
 $(this).siblings().children(".procus-option-input-child").slideUp(); 
 });
// 三级选择
$('.input-child').click(function() {
$(this).addClass('active').siblings().removeClass('active');
});





$('.procus input').on('input', function() {
var inputName = $(this).attr('name');
var inputValue = $(this).val();
var inputPrice = $(this).attr('data-price')

console.log(inputName);
 console.log(inputValue); 

switch (inputName) {
case 'Haircut':

    
if(inputValue == "I want to order my length"){
      ymqJq('.stock-haircut input').val(inputValue).data('price',Number(inputPrice.replace(/[^0-9\.-]+/g,""))).change();
function handleSlideChange(swiper, selectedValuea, selectedValueb, selectedValuec, selectedValued, selectedValuee, selectedValuef ) {
  var inputVal = 'Front: ' + selectedValuea + 'inch   /  Top: ' + selectedValueb + 'inch  /  Crown: ' + selectedValuec + 'inch  /  Back: ' + selectedValued + 'inch  /  Temples: '+ selectedValuee + 'inch  /  Sides: '+ selectedValuef + 'inch:';
    ymqJq('.stock-haircut input').val(inputVal).data('price',Number(inputPrice.replace(/[^0-9\.-]+/g,""))).change();
}
var swiperaa = new Swiper('.swiper-cap-a', {
  direction: 'vertical',
  loop: true,
  mousewheel: true,
  slidesPerView: 3
});
var swiperab = new Swiper('.swiper-cap-b', {
  direction: 'vertical',
  loop: true,
  mousewheel: true,
  slidesPerView: 3
});
var swiperac = new Swiper('.swiper-cap-c', {
  direction: 'vertical',
  loop: true,
  mousewheel: true,
  slidesPerView: 3
});
var swiperad = new Swiper('.swiper-cap-d', {
  direction: 'vertical',
  loop: true,
  mousewheel: true,
  slidesPerView: 3
});
  var swiperae = new Swiper('.swiper-cap-e', {
  direction: 'vertical',
  loop: true,
  mousewheel: true,
  slidesPerView: 3
});
var swiperaf = new Swiper('.swiper-cap-f', {
  direction: 'vertical',
  loop: true,
  mousewheel: true,
  slidesPerView: 3
});
swiperaa.update();
swiperab.update();
swiperac.update();
swiperad.update();
swiperae.update();
swiperaf.update();
swiperaa.on('slideChange', function () {
  var selectedItem = this.slides[this.activeIndex];
  var selectedValuea = selectedItem.querySelector('.sp-num-in').textContent;
  var selectedValueb = swiperab.slides[swiperab.activeIndex].querySelector('.sp-num-in').textContent;
    var selectedValuec = swiperac.slides[swiperac.activeIndex].querySelector('.sp-num-in').textContent;
    var selectedValued = swiperad.slides[swiperad.activeIndex].querySelector('.sp-num-in').textContent;
    var selectedValuee = swiperae.slides[swiperae.activeIndex].querySelector('.sp-num-in').textContent;
    var selectedValuef = swiperaf.slides[swiperaf.activeIndex].querySelector('.sp-num-in').textContent;
  handleSlideChange(this, selectedValuea, selectedValueb,selectedValuec,selectedValued,selectedValuee,selectedValuef);
});
swiperab.on('slideChange', function () {
  var selectedItem = this.slides[this.activeIndex];
  var selectedValueb = selectedItem.querySelector('.sp-num-in').textContent;
  var selectedValuea = swiperaa.slides[swiperaa.activeIndex].querySelector('.sp-num-in').textContent;
    var selectedValuec = swiperac.slides[swiperac.activeIndex].querySelector('.sp-num-in').textContent;
    var selectedValued = swiperad.slides[swiperad.activeIndex].querySelector('.sp-num-in').textContent;
    var selectedValuee = swiperae.slides[swiperae.activeIndex].querySelector('.sp-num-in').textContent;
    var selectedValuef = swiperaf.slides[swiperaf.activeIndex].querySelector('.sp-num-in').textContent;
  handleSlideChange(this, selectedValuea, selectedValueb,selectedValuec,selectedValued,selectedValuee,selectedValuef);
});
  swiperac.on('slideChange', function () {
  var selectedItem = this.slides[this.activeIndex];
  var selectedValuec = selectedItem.querySelector('.sp-num-in').textContent;
  var selectedValueb = swiperab.slides[swiperab.activeIndex].querySelector('.sp-num-in').textContent;
    var selectedValuea = swiperaa.slides[swiperaa.activeIndex].querySelector('.sp-num-in').textContent;
    var selectedValued = swiperad.slides[swiperad.activeIndex].querySelector('.sp-num-in').textContent;
    var selectedValuee = swiperae.slides[swiperae.activeIndex].querySelector('.sp-num-in').textContent;
    var selectedValuef = swiperaf.slides[swiperaf.activeIndex].querySelector('.sp-num-in').textContent;
  handleSlideChange(this, selectedValuea, selectedValueb,selectedValuec,selectedValued,selectedValuee,selectedValuef);
});
  swiperad.on('slideChange', function () {
  var selectedItem = this.slides[this.activeIndex];
  var selectedValued = selectedItem.querySelector('.sp-num-in').textContent;
  var selectedValueb = swiperab.slides[swiperab.activeIndex].querySelector('.sp-num-in').textContent;
    var selectedValuec = swiperac.slides[swiperac.activeIndex].querySelector('.sp-num-in').textContent;
    var selectedValuea = swiperaa.slides[swiperaa.activeIndex].querySelector('.sp-num-in').textContent;
    var selectedValuee = swiperae.slides[swiperae.activeIndex].querySelector('.sp-num-in').textContent;
    var selectedValuef = swiperaf.slides[swiperaf.activeIndex].querySelector('.sp-num-in').textContent;
  handleSlideChange(this, selectedValuea, selectedValueb,selectedValuec,selectedValued,selectedValuee,selectedValuef);
});
  swiperae.on('slideChange', function () {
  var selectedItem = this.slides[this.activeIndex];
  var selectedValuee = selectedItem.querySelector('.sp-num-in').textContent;
  var selectedValueb = swiperab.slides[swiperab.activeIndex].querySelector('.sp-num-in').textContent;
    var selectedValuec = swiperac.slides[swiperac.activeIndex].querySelector('.sp-num-in').textContent;
    var selectedValued = swiperad.slides[swiperad.activeIndex].querySelector('.sp-num-in').textContent;
    var selectedValuea = swiperaa.slides[swiperaa.activeIndex].querySelector('.sp-num-in').textContent;
    var selectedValuef = swiperaf.slides[swiperaf.activeIndex].querySelector('.sp-num-in').textContent;
  handleSlideChange(this, selectedValuea, selectedValueb,selectedValuec,selectedValued,selectedValuee,selectedValuef);
});
  swiperaf.on('slideChange', function () {
  var selectedItem = this.slides[this.activeIndex];
  var selectedValuef = selectedItem.querySelector('.sp-num-in').textContent;
  var selectedValueb = swiperab.slides[swiperab.activeIndex].querySelector('.sp-num-in').textContent;
    var selectedValuec = swiperac.slides[swiperac.activeIndex].querySelector('.sp-num-in').textContent;
    var selectedValued = swiperad.slides[swiperad.activeIndex].querySelector('.sp-num-in').textContent;
    var selectedValuee = swiperae.slides[swiperae.activeIndex].querySelector('.sp-num-in').textContent;
    var selectedValuea = swiperaa.slides[swiperaa.activeIndex].querySelector('.sp-num-in').textContent;
  handleSlideChange(this, selectedValuea, selectedValueb,selectedValuec,selectedValued,selectedValuee,selectedValuef);
});  
}else{
    ymqJq('.stock-haircut input').val(inputValue).data('price',Number(inputPrice.replace(/[^0-9\.-]+/g,""))).change();
}

if(inputValue !== "Upload hairstyle images you want"){
  $("#image1").val(""); 
  $("#image1").siblings("span").empty(); 
}


    

 break; 
  
case 'Hairstyles':
 ymqJq('.stock-haircut input').val(inputValue).data('price',Number(inputPrice.replace(/[^0-9\.-]+/g,""))).change();
 break; 



case 'Cut to size':
        ymqJq('.stock-cut-to-size input').val(inputValue).data('price',Number(inputPrice.replace(/[^0-9\.-]+/g,""))).change();
if(inputValue == "Yes, cut to my size"){
function handleSlideChange(swiper, selectedValueaaa, selectedValuebbb) {
  var result = parseFloat(selectedValueaaa) * parseFloat(selectedValuebbb);
  var inputVal = 'Width: ' + selectedValueaaa + 'inch   /   Length: ' + selectedValuebbb + 'inch';
    ymqJq('.stock-cut-to-size input').val(inputVal).data('price',Number(inputPrice.replace(/[^0-9\.-]+/g,""))).change();
}

var swipera = new Swiper('.swiper-width-a', {
  direction: 'vertical',
  loop: true,
  mousewheel: true,
  slidesPerView: 3
});

var swiperb = new Swiper('.swiper-height-a', {
  direction: 'vertical',
  loop: true,
  mousewheel: true,
  slidesPerView: 3
});

swiperb.update();
swipera.update();

swipera.on('slideChange', function () {
  var selectedItem = this.slides[this.activeIndex];
  var selectedValueaaa = selectedItem.querySelector('.sp-num-in').textContent;
  var selectedValuebbb = swiperb.slides[swiperb.activeIndex].querySelector('.sp-num-in').textContent;
  handleSlideChange(this, selectedValueaaa, selectedValuebbb);
});

swiperb.on('slideChange', function () {
  var selectedItem = this.slides[this.activeIndex];
  var selectedValuebbb = selectedItem.querySelector('.sp-num-in').textContent;
  var selectedValueaaa = swipera.slides[swipera.activeIndex].querySelector('.sp-num-in').textContent;
  handleSlideChange(this, selectedValueaaa, selectedValuebbb);
});
}else{
    ymqJq('.stock-cut-to-size input').val(inputValue).data('price',"0").change();
  
}
 break; 

case 'Trim excess edge':
    ymqJq('.stock-trim-excess-edge input').val(inputValue).data('price',"0").change()

  break;   
  }  
  
})

  











  
});


    function getObjectURL(file) {
      var url = null;
      if (window.createObjectURL != undefined) { // basic
        url = window.createObjectURL(file);
      } else if (window.URL != undefined) { // mozilla(firefox)
        url = window.URL.createObjectURL(file);
      } else if (window.webkitURL != undefined) { // webkit or chrome
        url = window.webkitURL.createObjectURL(file);
      }
      return url;
    }

    // Move the gome function outside the HTML code block
    function gome(obj) {
      var objUrl = getObjectURL(obj.files[0]);
      if (objUrl) {
        $(obj).parent().find('span').html("<img src='" + objUrl + "' width='100%'>"); 
      }
    }